// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qk-0";